import Button from "../../../../../../common/components/atom/Button/Button";
import TextInput from "../../../../../../common/components/atom/TextInput/TextInput";
import MinigridSelector from "../../../../../minigrid/components/MinigridSelector/MinigridSelector";
import { Minigrid } from "../../../../../minigrid/types/minigridtypes";

import styles from "./CreateUpdatePlanBTFormView.module.scss";


export interface FormData {
  name?: string | undefined | null;
  description?: string | undefined | null;
  minigrid?: Minigrid | null | undefined;
  initMinigridId?: string | null;
}

export interface ValidationFormDataPlanBT {
  isErrorName: boolean,
  isErrorDescription: boolean
  isErrorImagePlan: boolean
  isErrorMinigrid: boolean
}



export interface CreateUpdatePlanBTFormViewProps {
  data?:FormData | null;
  setImages?: (images: File[]) => void;
  imageList?: File[] | undefined;
  error?: string | null;
  setData : (data: FormData) => void;
  isErrorInput?: ValidationFormDataPlanBT;
  labelSubmitBtn?: string;
  onSubmit?: () => void;
  onCancel?: () => void;
  isLoading?: boolean;
  excludeMinigridIds?: string[];
}

export default function CreateUpdatePlanBTFormView({data, error, isErrorInput, setData, setImages, imageList,   labelSubmitBtn = 'Envoyer',
  onSubmit, isLoading, excludeMinigridIds}:CreateUpdatePlanBTFormViewProps) {
  
  return (
    <div className={styles["container-form"]}>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--name"],
        ].join(" ")}
      >
        <TextInput
          label="Nom"
          value={data?.name}
          onChange={(e) =>
            setData({ ...data, name: e.target.value })
          }
          error={isErrorInput?.isErrorName}
        />
      </div>
      <div
        className={[
          styles["container-form__item"],
          styles["container-form__item--description"],
        ].join(" ")}
      >
        <TextInput
          label="Description"
          value={data?.description}
          rows={10}
          onChange={(e) =>
            setData({ ...data, description: e.target.value })
          }
          error={isErrorInput?.isErrorDescription}
        />
      </div>
      <div
        className={[
          styles["container-form__item"],
        
        ].join(" ")}
      >
        <MinigridSelector
          label="Minigrid"
          onChange={(minigrid) =>
            setData({ ...data, minigrid: minigrid })
          }
          value={data?.minigrid}
          isError={isErrorInput?.isErrorMinigrid}
          initMinigridId={data?.initMinigridId}
          excludeMinigridIds={excludeMinigridIds}
        />
      </div>

      <div className={styles["container-form__section"]}>
        <Button
          label={labelSubmitBtn}
          onClick={onSubmit}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
